import { FC } from "react";
import styles from "./AvatarIcon.module.scss";

interface IAvatarProps {
    name: string;
    url?: string;    
}

export const Avatar: FC<IAvatarProps> = ({ name, url }) => {
    const getImage = () => <img src={url} alt={`${name} avatar`} className={styles.avatarImage} />;
    const getLetter = () => name ? name.substring(0, 1).toUpperCase() : '';
    const getAvatar = () => url ? getImage() : getLetter();
    
    return <div className={styles.avatar}>{ getAvatar() }</div>;
};
